import { Loader2 } from "lucide-react";
import DocumentiGenerati from "@/components/DocumentiGenerati";
import { ZonaCaricamento } from "@/components/PraticaDocsBox";

const dataIt = (s) => (s ? new Date(s).toLocaleDateString("it-IT") : "");

// Documenti del cliente e atti generati, uno accanto all'altro come nella scheda pratica.
export default function ClienteDocumenti({ cliente, files, connected, isLoading }) {
  return (
    <>
      <div className="hidden md:block">
        <ZonaCaricamento cliente={cliente}
          testo="Trascina qui i file. Finiscono nella cartella Drive del cliente, nella sottocartella giusta." />
      </div>

      <div className="sub grid md:grid-cols-2 min-w-0" data-testid="box-documenti-cliente">
        <div className="min-w-0 border-b md:border-b-0 md:border-r border-[#E8E6DF]" data-testid="cliente-file-drive">
          <div className="subt">
            <span>Documenti del cliente</span>
            <span className="text-[13px] font-normal normal-case tracking-normal text-[#5A5A5A]">{files.length} file</span>
          </div>
          <div className="max-h-[320px] overflow-y-auto">
            {!connected && <div className="riga text-[#8A2E2E]">Collega Google in Impostazioni per vedere i documenti.</div>}
            {connected && isLoading && <div className="riga text-[#5A5A5A]"><Loader2 className="w-4 h-4 animate-spin" /> Carico i documenti…</div>}
            {connected && !isLoading && files.length === 0 && <div className="riga text-[#5A5A5A]">Nessun documento nella cartella.</div>}
            {files.map((f) => (
              <div key={f.id} data-testid="cliente-file-riga" className="riga">
                <span className="flex-grow min-w-0 truncate"
                  title={`${f.name}${f.categoria ? ` · ${f.categoria}` : ""}${f.modifiedTime ? ` · ${dataIt(f.modifiedTime)}` : ""}`}>
                  {f.name}
                </span>
                <a href={f.webViewLink} target="_blank" rel="noreferrer"
                  className="text-[13px] font-semibold no-underline shrink-0">Apri</a>
              </div>
            ))}
          </div>
        </div>
        <div className="min-w-0" data-testid="cliente-atti-generati">
          <DocumentiGenerati clienteId={cliente.id} titolo="Contratti e atti generati"
            nota="Qui finisce tutto ciò che esce da «Genera documento»." />
        </div>
      </div>

      <span className="text-[13px] text-[#4A4A48]">
        La ricerca dei doppioni su Drive non sta più qui: è un'operazione d'archivio e vive in Impostazioni.
      </span>
    </>
  );
}
